import {  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LuggageTableHeader from './LuggageTableHeader'
import { destinationHeader } from './LuggageConstant'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import DestinationTableBody from './DestinationTableBody'
import { navigation3 } from '../../../../common/helper'

const DestinationTable = ({UseToPayAsCOD, tableData, setTableData, sourceTableData }) => {
    const [searchData, setSearchData] = useState('')
    const [reportData, setReportData] = useState([])
    useEffect(() => {
        setReportData(tableData)
        setSearchData('')
    }, [tableData])
    const handleTableChecked = (event, index, field) => {
        let newDate = [...reportData.map((val, i) => {
            if (i === index) {
                let newArr = val.DestinationData.map((val1) => ({ ...val1, [field]: event.target.checked ? 1 : 0 }));
                val.DestinationData = newArr;
                return { ...val, [field]: event.target.checked }
            }
            return val
        })]
        setTableData(newDate)
    }
    const handleDestBranchChecked = (value, index, field, branchIndex) => {
        let newDate = [...reportData.map((val, i) => {
            if (i === index) {
                let newArr = val.DestinationData.map((val1, index1) => index1 === branchIndex ? { ...val1, [field]: value === 0 ? 1 : 0 } : val1)
                val.DestinationData = newArr
                return { ...val, [field]: newArr.some(item => item[field] === 1) ? true : false }
            }
            return val
        })]
        setTableData(newDate)
    }
    return (
        <TableContainer component={Paper} className='scrollBlue' style={{ maxHeight: '44vh', marginTop: '16px', marginBottom: "5px" }} >
            <Table stickyHeader size="small" aria-label="a dense table" sx={{
                '& .MuiTableCell-root': {
                    padding: '6px 8px !important'
                }
            }}>
                <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                    <LuggageTableHeader columnDefs={destinationHeader} UseToPayAsCOD={UseToPayAsCOD}/>
                    <TableRow>
                        {destinationHeader.map((col, index) => col.showfilter ?
                            <TableCell key={`FTH-${index}`}>
                                <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                    <input
                                        className="field"
                                        name="cancelSearchInput"
                                        style={{ width: '100%' }}
                                        placeholder="Contains"
                                        id='searchContain'
                                        value={searchData}
                                        onChange={(e) => {
                                            setSearchData(e.target.value)
                                            setReportData(tableData.filter((val) => (e.target.value === "" || val?.Cityname?.toLowerCase().includes(e.target.value?.toLowerCase()))))
                                        }}
                                        onKeyDown={(e) => {
                                            navigation3(e, `DestIcons-0`, sourceTableData.length > 0 ? `IsFOC-${sourceTableData.length - 1}` : 'activeBtn', () => { })
                                        }}
                                    />
                                    <FilterAltIcon sx={{ color: '#aaa !important' }} />
                                </div>
                            </TableCell>
                            : <TableCell></TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {reportData.map((obj, index) => <DestinationTableBody items={obj} index={index} handleTableChecked={handleTableChecked} handleDestBranchChecked={handleDestBranchChecked} sourceTableData={sourceTableData} reportData={reportData} />)}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default DestinationTable